import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    theme: 'light',
    toggleMenuShown: true
};
const uiSlice = createSlice({
    name: 'uiData',
    initialState,
    reducers: {
        setTheme(state, action) {
            state.theme = action.payload;
        },
        setToggleMenuShown(state, action) {
            state.toggleMenuShown = action.payload;
        }
    }
});
export const { setTheme, setToggleMenuShown } = uiSlice.actions;
export const uiReducer = uiSlice.reducer;
